import { Router } from '@angular/router';

export function redirectToPreDashboard(router: Router) {
  const predashboardUrlRelativeToBase = router
    .createUrlTree(['pre-dashboard'])
    .toString();
  router.navigate([predashboardUrlRelativeToBase]);
}
